import GridCellBase from '../GridCellBase';
import CellThumbnailViewerView from './CellThumbnailViewerView';

class CellThumbnailViewer extends GridCellBase {
  constructor(row, column, value, parentElement, propsData, dataset, grid) {
    super(row, column, value, parentElement, propsData, dataset, grid);

    // grid 에 사용자명을 저장할 map property를 추가
    if( !grid[column]){
      grid[column] = {};
    }
    if( !grid[column].thumbnailMap){
      grid[column].thumbnailMap = new Map();
    }
    this.setValue(value);
  }

  getBaseComponent() { // cell에 그려질 기본 컴포넌트를 반환
    return CellThumbnailViewerView;
  }

  getEventName() { // 컴포넌트 데이터 변경을 감지할 이벤트 이름
    return null;
  }

  decoratePropsData(row, column, value, propsData) { // 컴포넌트의 초기 props 설정
    this.grid.pageId = propsData.pageId;
  }

  setValue(value) { // 컴포넌트의 값을 변경 하는 함수
    if (this.getComponentInstance()) {
      // 맵에 저장된 썸네일이 없을 경우
      if (!this.hasThumbnail()) {
        // fileUid 가 존재하면 해당 fileUid 로 썸네일을 가져오고(API 호출)
        // fileUid 가 존재하지 않을 경우엔 컴포넌트에 null 로 셋팅
        if (!utils.isEmpty(this.getCurrentRowValue('fileUid'))) {
          this.downloadThumbnail().then(imgSrc => {
            this.addThumbnail(imgSrc);
            this.getComponentInstance().setValue(this.getThumbnail(), this.getCurrentRowValue('fileUid'));
          }).catch(err => {
            this.addThumbnail('');
            this.getComponentInstance().setValue(this.getThumbnail(), this.getCurrentRowValue('fileUid'));
          });
        } else {
          // fileUid 가 존재하지 않을 경우에 컴포넌트에 null 로 셋팅
          this.getComponentInstance().setValue('', this.getCurrentRowValue('fileUid'));
        }
      } else {
        // 맵에 저장된 썸네일이 존재할 경우엔 그 값으로 컴포넌트를 셋팅
        this.getComponentInstance().setValue(this.getThumbnail(), this.getCurrentRowValue('fileUid'));
      }
    }
  }

  getValueFromEvent(event) { // 이벤트로부터 실제 dataset을 변경할 value 를 반환
    return event;
  }

  bindEvents() {
    super.bindEvents();
    this.dataset.$on(this.dataset.EVENTS.RAW_DATA_CHANGED, this.onDatasetChanged.bind(this));
  }

  onDatasetChanged(){
    if(this.grid[this.columnName] && this.grid[this.columnName].thumbnailMap){
      this.grid[this.columnName].thumbnailMap.clear();
    }
  }

  /**
   * 썸네일 이미지를 grid의 맵 변수에 추가
   * @function addThumbnail
   * @param {arrayBuffer} value: image src
   * @returns {Map}
   */
  addThumbnail(value){
    let currKey = this.getCurrentRowValue('fileUid');
    if (utils.isEmpty(currKey)) {
      return currKey;
    } else {
      return this.grid[this.columnName].thumbnailMap.set(currKey, value);
    }
  }

  /**
   * 매개변수로 넘어가는 key에 일치하는 이미지 소스를 반환
   * @function getThumbnail
   * @returns {String} 이미지 소스 or null
   */
  getThumbnail(){
    let currKey = this.getCurrentRowValue('fileUid');
    if (utils.isEmpty(currKey)) {
      return currKey;
    } else {
      return this.grid[this.columnName].thumbnailMap.get(currKey);
    }
  }

  /**
   * 매개변수로 넘어가는 key에 일치하는 엔트리 존재유무를 true/false 로 반환
   * @function hasThumbnail
   * @returns {Boolean} true/false
   */
  hasThumbnail(){
    let currKey = this.getCurrentRowValue('fileUid');
    if (utils.isEmpty(currKey)) {
      return false;
    } else {
      return this.grid[this.columnName].thumbnailMap.has(currKey);
    }
  }

  /**
   * image thumbnail 다운로드하여 imgSrc 로 바인딩 함
   * @function downloadThumbnail
   * @param {None}
   * @returns {None}
   */
  downloadThumbnail() {
    const that = this;

    return new Promise((resolve, reject) => {
      http.request(that.grid.pageId, 'DTS_CMS_00045', {
        path: {
          'target-path': 'storage',
        },
        query: {
          fileUid: that.getCurrentRowValue('fileUid'),
        },
        responseType: 'arraybuffer',
      }, true).then(res => {
        const reader = new FileReader();
        const blob = new Blob([res.data], { type: res.headers['content-type'] });

        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onabort = () => {
          reject(reader.error);
        };
        
        //reader.readAsDataURL(new File([blob], 'not_required_exact_filename_so_here_make_dummy_filename'));
        reader.readAsDataURL(blob); // for ie - can't use File
      }).catch(err => {
        // let errStr = utils.arraybufferToString(err.data);
        // let errJson = JSON.parse(errStr);

        // console.log(errJson);
        reject(err);
      });
    })
  }

  /**
   * 
   */
  getCurrentRowValue(fieldName) {
    return this.getCurrentDataRow()[fieldName];
  }

}

export default CellThumbnailViewer;
